import { IncomingMessage } from 'http';
import { NextApiResponse } from 'next';
import { getTokenCookieFromContext } from 'utils/helpers/server/cookies';
import { TokenPurpose, getJwtUserName } from 'utils/helpers/cookies.shared';

/**
 * TODO: tento kód po otestování na produkci smazat.
 *
 * Jediné místo s pravidly přístupu k modulu Databáze trenérů (dočasné omezení).
 * Modul je dostupný, pokud:
 *   - požadavek běží na veřejném DEV hostu (test i bez přihlášení), NEBO
 *   - jde o přihlášený účet z allowlistu (ACC/prod).
 *
 * Vyhodnocuje se výhradně na serveru; klient (menu) dostává jen výsledný
 * boolean přes props/context, takže nehrozí hydration mismatch.
 */

// Hosty, kde je modul otevřený i nepřihlášeným (přesná shoda hostname).
const COACHES_PUBLIC_HOSTS = ['dev.is.fotbal.cz', 'localhost', '127.0.0.1'];

// Účty, které modul vidí i na neveřejných hostech (ACC/prod).
const COACHES_ALLOWED_EMAILS = [
    'naseisko@fotbal.cz', // PROD
    'trenervlada@fotbal.cz', // AKC
    'test@fotbal.cz', // Localhost
];

// Reálný host požadavku – za nginx ingressem je v x-forwarded-host.
const getRequestHost = (req: IncomingMessage): string | null => {
    const forwarded = req.headers['x-forwarded-host'];
    const raw =
        (Array.isArray(forwarded) ? forwarded[0] : forwarded) ??
        req.headers.host;
    return raw ? raw.split(':')[0].trim().toLowerCase() : null;
};

const isAllowedEmail = (email: string | null): boolean =>
    !!email && COACHES_ALLOWED_EMAILS.includes(email.trim().toLowerCase());

/**
 * Host, kde je modul veřejný (i pro nepřihlášené). Používá se i k rozhodnutí,
 * zda povolit SSR stránku bez přihlášení (getGlobalProps allowNotLoggedIn).
 */
export const isCoachesPublicRequest = (req: IncomingMessage): boolean =>
    COACHES_PUBLIC_HOSTS.includes(getRequestHost(req) ?? '');

/**
 * Hlavní pravidlo přístupu – sdílené pro viditelnost položky v menu,
 * SSR stránky (redirect) i /api routy (403).
 */
export const isCoachesRequestAllowed = (
    req: IncomingMessage,
    res: NextApiResponse
): boolean =>
    isCoachesPublicRequest(req) ||
    isAllowedEmail(
        getJwtUserName(getTokenCookieFromContext(req, res, TokenPurpose.Access))
    );
